<!-- TopBanner.vue -->
<template>
  <div class="top-banner" v-show="topBanner.img_url && loaded">
<!--    <a :href="topBanner.pc_url" target="_blank">-->
      <router-link :to="topBanner.pc_url"><img :src="topBanner.img_url" alt="顶部广告" /></router-link>
  </div>
</template>

<script>
import { getIndexdingbu } from "@/api/index";

export default {
  data() {
    return {
      topBanner: {},
      loaded: false
    };
  },
  mounted() {
    getIndexdingbu().then(res => {
      if (res.code === 200 && res.data) {
        this.topBanner = res.data;
        this.loaded = true;
      }
    });
  }
};
</script>
<style  lang="less" scoped>
.top-banner {
  width: 100%;
  height: auto;
  overflow: hidden;
  margin-bottom: 3px;

img {
  width: 100%;
  height: 100px;
  display: block;
  transition: all 0.3s ease-in-out;
}

&:hover img {
   transform: scale(1.02);
 }
}

</style>



// WEBPACK FOOTER //
// src/components/nav/TopBanner.vue